var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-dating",on:{"scroll":_vm.onScroll}},[(_vm.scrollTop !== 0)?_c('div',{staticClass:"top-border"}):_vm._e(),_c('div',{staticClass:"padding"}),_c('MyAgents'),_c('Suggested',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }